import { Component } from '@angular/core';

@Component({
  selector: 'loading-dots-modal-component',
  templateUrl: './loading-dots-modal.component.html',
  styleUrls: ['./loading-dots-modal.component.scss']
})
export class LoadingDotsModalComponent {

  constructor() { }

}
